<template>
  <div class="carousel_wrap">
    <el-carousel height="40vw" loop arrow="never" :autoplay="false" class="hidden-xs-only" ref="carouselPC" @change="handleCarouselChange">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <template v-if="item.type === 'video'">
          <video
            class="video_item"
            :src="item.src"
            controls
            autoplay
            muted
            loop
            @play="handleVideoPlay"
            @pause="handleVideoPause"
            @ended="handleVideoEnded"
            ref="video"
            @click="handleVideoClick"
          ></video>
        </template>
        <template v-else-if="item.type === 'image'">
          <img :src="item.src" alt="">
          <div class="tips_font" v-if="item.line1 || item.line2">
            <h1>{{ item.line1 }}</h1>
            <h1>{{ item.line2 }}</h1>
          </div>
          <div v-if="index === 0" class="button-container">
            <a href="/demo" class="experience-btn">预约演示</a>
          </div>
        </template>
      </el-carousel-item>
    </el-carousel>

    <el-carousel height="50vw" loop arrow="never" :autoplay="false" class="hidden-sm-and-up" ref="carouselMobile" @change="handleCarouselChange">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <template v-if="item.type === 'video'">
          <video
            class="video_item"
            :src="item.src"
            controls
            :autoplay="false"
            muted
            loop
            @play="handleVideoPlay"
            @pause="handleVideoPause"
            ref="video"
            @click="handleVideoClick"
          ></video>
        </template>
        <template v-else-if="item.type === 'image'">
          <img :src="item.src" alt="">
          <div class="tips_font" v-if="item.line1 || item.line2">
            <h1>{{ item.line1 }}</h1>
            <h1>{{ item.line2 }}</h1>
          </div>
          <div v-if="index === 0" class="button-container">
            <a href="/demo" class="experience-btn">预约演示</a>
          </div>
        </template>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          type: 'image',
          src: require('@/assets/img/banner2.jpg'),
          line1: '领先的医疗器械数字化平台',
          line2: '做医疗器械，就用柳叶云',
        },
        {
          type: 'video',
          src: '/video/publicity.mp4',
          line1: '',
          line2: '',
        }
      ],
      isVideoPlaying: false,
      currentIndex: 0
    }
  },
  methods: {
    handleVideoClick(e) {
      // 防止点击视频时轮播图切换
      e.stopPropagation();
    },
    handleCarouselChange(index) {
      this.currentIndex = index;
      const currentItem = this.imgList[index];
      
      // 如果切换到视频项
      if (currentItem.type === 'video') {
        // 确保视频重新开始播放
        if (this.$refs.video && this.$refs.video[0]) {
          this.$refs.video[0].currentTime = 0;
          this.$refs.video[0].play();
        }
      } else {
        // 如果切换到图片项，确保视频暂停
        if (this.$refs.video && this.$refs.video[0]) {
          this.$refs.video[0].pause();
        }
      }
    },
    handleVideoPlay() {
      this.isVideoPlaying = true;
      // 暂停轮播
      if (this.$refs.carouselPC) {
        this.$refs.carouselPC.pauseTimer();
      }
      if (this.$refs.carouselMobile) {
        this.$refs.carouselMobile.pauseTimer();
      }
    },
    handleVideoPause() {
      this.isVideoPlaying = false;
      // 恢复轮播
      if (this.$refs.carouselPC) {
        this.$refs.carouselPC.startTimer();
      }
      if (this.$refs.carouselMobile) {
        this.$refs.carouselMobile.startTimer();
      }
    },
    handleVideoEnded() {
      this.isVideoPlaying = false;
      // 视频播放结束后，手动切换到下一项
      const nextIndex = (this.currentIndex + 1) % this.imgList.length;
      if (this.$refs.carouselPC) {
        this.$refs.carouselPC.setActiveItem(nextIndex);
      }
      if (this.$refs.carouselMobile) {
        this.$refs.carouselMobile.setActiveItem(nextIndex);
      }
    }
  }
}
</script>

<style lang="scss">
.carousel_wrap {
  width: 100%;
  position: relative;
  overflow: hidden;
  
  // 确保移动端轮播图不被导航栏遮挡
  @media screen and (max-width: 768px) {
    margin-top: 0; // 移除之前的margin，因为已经在父容器中处理了
  }

  // 移除CSS媒体查询，让vw单位自然响应

  .video_item {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  // 确保图片不会溢出容器
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .tips_font {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 2;

    h1 {
      color: #ffffff;
      font-size: 48PX;
      font-weight: 600;
      margin: 0;
      line-height: 1.4;
      text-shadow: 0 4PX 8PX rgba(0, 0, 0, 0.5), 0 2PX 4PX rgba(0, 0, 0, 0.3);
      opacity: 0;
      transform: translateY(20PX);
      animation: fadeInUp 0.8s forwards;

      &:nth-child(2) {
        animation-delay: 0.3s;
      }

      @media screen and (max-width: 1200PX) {
        font-size: 36PX;
      }

      @media screen and (max-width: 768PX) {
        font-size: 24PX;
        white-space: nowrap;
      }

      @media screen and (max-width: 480PX) {
        font-size: 20PX;
      }
    }
  }

  .button-container {
    position: absolute;
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    opacity: 0;
    animation: fadeIn 0.8s forwards;
    animation-delay: 0.6s;

    .experience-btn {
      display: inline-block;
      padding: 12PX 40PX;
      font-size: 20PX;
      color: #ffffff;
      background: linear-gradient(135deg, #1890ff, #52c41a);
      border-radius: 30PX;
      text-decoration: none;
      transition: all 0.3s ease;
      border: none;
      cursor: pointer;
      box-shadow: 0 4PX 15PX rgba(24, 144, 255, 0.3);

      &:hover {
        transform: translateY(-2PX);
        box-shadow: 0 6PX 20PX rgba(24, 144, 255, 0.4);
      }

      @media screen and (max-width: 1200PX) {
        padding: 10PX 35PX;
        font-size: 18PX;
      }

      @media screen and (max-width: 768PX) {
        padding: 8PX 30PX;
        font-size: 16PX;
      }

      @media screen and (max-width: 480PX) {
        padding: 6PX 25PX;
        font-size: 14PX;
      }
    }
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20PX);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

::v-deep .el-carousel__indicators {
  bottom: 20PX;

  .el-carousel__button {
    width: 30PX;
    height: 3PX;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 2PX;
    transition: all 0.3s ease;
  }

  .el-carousel__indicator.is-active {
    .el-carousel__button {
      background: #ffffff;
      width: 40PX;
    }
  }
}

::v-deep .el-carousel__arrow {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4PX);
  border: none;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.5);
  }

  i {
    color: #ffffff;
  }
}

// 确保轮播图容器不会溢出
::v-deep .el-carousel {
  overflow: hidden;
}

::v-deep .el-carousel__container {
  overflow: hidden;
}

::v-deep .el-carousel__item {
  overflow: hidden;
}
</style>